function getNthSundayUTC(year: number, month: number, n: number): number {
  const firstOfMonth = new Date(Date.UTC(year, month - 1, 1));
  const firstWeekday = firstOfMonth.getUTCDay();
  const firstSunday = firstWeekday === 0 ? 1 : 8 - firstWeekday;
  return firstSunday + (n - 1) * 7;
}

// US Eastern DST: starts 2:00 AM EST (07:00 UTC) on the 2nd Sunday of March,
// ends 2:00 AM EDT (06:00 UTC) on the 1st Sunday of November. Comparing the
// exact UTC instant (not just the calendar date) avoids mislabeling the hours
// right around the transition.
function getEasternUTCOffsetHoursForInstant(utcMs: number): number {
  const year = new Date(utcMs).getUTCFullYear();
  const dstStartDay = getNthSundayUTC(year, 3, 2);
  const dstEndDay = getNthSundayUTC(year, 11, 1);
  const dstStart = Date.UTC(year, 2, dstStartDay, 7, 0, 0);
  const dstEnd = Date.UTC(year, 10, dstEndDay, 6, 0, 0);
  return utcMs >= dstStart && utcMs < dstEnd ? 4 : 5;
}

export function formatTime(timeStr: string, dateStr?: string): string {
  try {
    const [hoursStr, minutesStr] = timeStr.split(':');
    const utcHour = parseInt(hoursStr, 10);
    const utcMinute = parseInt(minutesStr, 10) || 0;

    let estHour = (utcHour - 5 + 24) % 24; // fallback when no date is available
    let isDaylightSaving = false;

    if (dateStr) {
      const [year, month, day] = dateStr.split('-').map(Number);
      if (year && month && day) {
        const utcInstantMs = Date.UTC(year, month - 1, day, utcHour, utcMinute);
        const offsetHours = getEasternUTCOffsetHoursForInstant(utcInstantMs);
        const estInstant = new Date(utcInstantMs - offsetHours * 60 * 60 * 1000);

        isDaylightSaving = offsetHours === 4;
        estHour = estInstant.getUTCHours();
      }
    }

    const ampm = estHour >= 12 ? 'PM' : 'AM';
    const hour12 = estHour % 12 || 12;
    const zoneLabel = isDaylightSaving ? 'EDT' : 'EST';
    return `${hour12}:${minutesStr} ${ampm} ${zoneLabel}`;
  } catch {
    return timeStr;
  }
}
